import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

const namespace = 'entities';
export const keyPrefix = 'list_form';
export const useCreateListFormTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  list_form: {
    title_create: 'Новый список',
    title_update: 'Изменить список',
    title_duplicate: 'Дублирование списка',
    subtitle: 'В новый список будут добавлено все содержимое списка {{name}}',
    user_data: {
      label: 'Название',
      placeholder: '',
    },
    department: {
      label: 'Подразделение владелец',
      placeholder: 'Выберите подразделение',
      empty: 'Подразделения не найдены',
    },
    owner_department_hint: 'Чтобы изменить подразделение владельца, перейдите в раздел “Управление доступом” или обратитесь к администратору.',
    submit_create: 'Создать',
    submit_update: 'Сохранить',
    cancel: 'Отмена',
  },
}) as Record<string, unknown>;

export const en = ({
  list_form: {
    title_create: 'New list',
    title_update: 'Edit list',
    title_duplicate: 'Duplicate list',
    subtitle: 'All content of the list {{name}} will be added to the new list',
    user_data: {
      label: 'Name',
      placeholder: '',
    },
    department: {
      label: 'Owner department',
      placeholder: 'Select department',
      empty: 'No departments found',
    },
    owner_department_hint: 'To change the owner department, go to Access management or contact your administrator.',
    submit_create: 'Create',
    submit_update: 'Save',
    cancel: 'Cancel',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  list_form: {
    title_create: 'Nova lista',
    title_update: 'Editar lista',
    title_duplicate: 'Duplicar lista',
    subtitle: 'Todo o conteúdo da lista {{name}} será adicionado à nova lista',
    user_data: {
      label: 'Nome',
      placeholder: '',
    },
    department: {
      label: 'Departamento proprietário',
      placeholder: 'Selecionar departamento',
      empty: 'Nenhum departamento encontrado',
    },
    owner_department_hint: 'Para alterar o departamento proprietário, acesse o gerenciamento de acesso ou entre em contato com o administrador.',
    submit_create: 'Criar',
    submit_update: 'Salvar',
    cancel: 'Cancelar',
  },
}) as Record<string, unknown>;

export const esEs = ({
  list_form: {
    title_create: 'Nueva lista',
    title_update: 'Editar lista',
    title_duplicate: 'Duplicar lista',
    subtitle: 'Todo el contenido de la lista {{name}} se añadirá a la nueva lista',
    user_data: {
      label: 'Nombre',
      placeholder: '',
    },
    department: {
      label: 'Departamento propietario',
      placeholder: 'Seleccionar departamento',
      empty: 'No se encontraron departamentos',
    },
    owner_department_hint: 'Para cambiar el departamento propietario, vaya a la gestión de acceso o póngase en contacto con el administrador.',
    submit_create: 'Crear',
    submit_update: 'Ahorrar',
    cancel: 'Cancelar',
  },
}) as Record<string, unknown>;
